import { ChangeDetectionStrategy, Component, Signal, computed } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';
import { EpcotConfigService } from 'packages/sports/web/app/src/common/epcot-config.service';

import { isBetBuilderPick } from '../../../core/utils';
import BaseComboBetComponent from './base-combo-bet.component';

@Component({
    selector: 'bs-digital-combo-bet',
    templateUrl: './combo-bet.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./combo-bet.component.scss'],
    standalone: false,
})
export default class ComboBetComponent extends BaseComboBetComponent {
    protected shouldShowHeader: Signal<boolean>;

    constructor(
        store: Store,
        private epcotConfigService: EpcotConfigService,
        private betslipConfig: BetslipConfig,
    ) {
        super(store);

        this.shouldShowHeader = computed(
            () =>
                this.epcotConfigService.isEnabled() &&
                this.betslipConfig.allowBetbuilderCombos &&
                this.pickList().length > 1 &&
                this.pickList().some((pick) => isBetBuilderPick(pick)),
        );
    }
}
